import React from 'react';

import { MailableFormContainer } from '@/components/postgrid/mailable-form';

interface WizardContainerProps {
  title: string;
  description: string;
  children: React.ReactNode;
  maxWidth?:
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | '7xl';
}

export const WizardContainer: React.FC<WizardContainerProps> = ({
  title,
  description,
  children,
  maxWidth = '4xl',
}) => {
  return (
    <MailableFormContainer maxWidth={maxWidth}>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {description && (
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        )}
      </div>
      {children}
    </MailableFormContainer>
  );
};
